import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageHeader } from '../components/page-header';
import { usePerformanceReviewAccess } from '../hooks';

/**
 * Base review template settings. Placeholder shell wired to the route in this
 * story; the template builder lands with the template story.
 */
const PerformanceReviewTemplateSettings: React.FC = () => {
  const { t } = useTranslation('performanceReview');
  const canView = usePerformanceReviewAccess({ adminOnly: true });

  if (!canView) {
    return null;
  }

  return (
    <div>
      <PageHeader
        title={t('template.title')}
        description={t('template.description')}
        testId="performance-review-template"
      />
    </div>
  );
};

export default PerformanceReviewTemplateSettings;
